module.exports = __webpack_public_path__ + "img/video-s.8d52238a.png";